export class Stato {

  stato: string;

  constructor(stato: string) {

    this.stato = stato || '' || 'attivo' || 'in programmazione' || 'chiuso' || 'dismesso';
  }
}
